import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { OrderListedFilterEntity } from '../../domain/entities/OrderListedFilterEntity'

export class OrderListedFilterModel extends OrderListedFilterEntity {
  constructor(dataDto: OrderListedFilterEntity) {
    super()
    mapEntityProperties<OrderListedFilterEntity>(this, dataDto)
  }
}
